import React, { useState } from "react";
import {
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
} from "reactstrap";
import classnames from "classnames";
import MasterUpdateRequestsApprovalTab from "./MasterUpdateRequestsApprovalTab";
import MasterUpdateRequestsPendingListTab from "./MasterUpdateRequestsPendingListTab.js";

const MasterUpdateRequestsApproval = () => {
    const [activeTab, setActiveTab] = useState("1");
    // const [reviewRequestResponseData, setReviewRequestResponseData] = useState(null);
    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };
    return (
        <div className="hl-vendor-need-approval-wrap hl-vl-common-wrap mt-3">
            <div className="hl-approval-tabs">
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === "1" })}
                            onClick={() => {
                                toggle("1");
                            }}
                        >
                            Approval
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: activeTab === "2" })}
                            onClick={() => {
                                toggle("2");
                            }}
                        >
                            Pending List
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                        <Row className="ag-grid-react custom-pagination without-filter-grid">
                            <MasterUpdateRequestsApprovalTab />
                        </Row>
                    </TabPane>
                    <TabPane tabId="2">
                        <Row>
                            <MasterUpdateRequestsPendingListTab />
                        </Row>
                    </TabPane>
                </TabContent>
            </div>

        </div>
    );
};
export default MasterUpdateRequestsApproval;
